<template>
<div>
  <input-text v-model="internalPersonnalInformations.email"
              validationRules="required|email"
              :validationTranslation="$t('models.user.email')"
              fieldName="email"
              fieldId="email"
              fieldType="email"
              :label="$t('models.user.email')"
              :required="true"
              :disabled="false"
              @input="onEmailInput" />

  <div v-if="mailCheckedEmail" class='form--notice form--suggestEmail'>
    {{ $t("models.user.error_email") }}<span @click="setEmail" class="email-suggestion">{{ mailCheckedEmail }}</span> ?
  </div>

  <div v-if="specialChar" class='form--notice error'>
    {{ $t("models.user.no_accents_error") }}
  </div>

  <div v-if="userExist && !existenceInEntity && !userExistDifferentRole" class="existence-notice">
    {{ isManager ? $t('UserForm.notice_manager_blue') : $t('UserForm.notice_blue') }}
  </div>

  <div v-if="userExist && existenceInEntity && !userExistDifferentRole" class="existence-notice red">
    {{ isManager ? $t('UserForm.notice_manager_red') : $t('UserForm.notice_red') }}
  </div>

  <div v-if="userExist && userExistDifferentRole" class="existence-notice red">
    {{ $t('UserForm.email_taken') }}
  </div>

  <input-text v-model="internalPersonnalInformations.last_name"
              validationRules="required"
              :validationTranslation="$t('models.user.last_name')"
              fieldName="last_name"
              fieldId="last_name"
              fieldType="text"
              :label="$t('models.user.last_name')"
              :required="true"
              :disabled="userExist && !userExistDifferentRole"
              @input="onChange('last_name', internalPersonnalInformations.last_name)" />

  <input-text v-model="internalPersonnalInformations.first_name"
              validationRules="required"
              :validationTranslation="$t('models.user.first_name')"
              fieldName="first_name"
              fieldId="first_name"
              fieldType="text"
              :label="$t('models.user.first_name')"
              :required="true"
              :disabled="userExist && !userExistDifferentRole"
              @input="onChange('first_name', internalPersonnalInformations.first_name)" />

  <input-text v-model="internalPersonnalInformations.phone_display"
              validationRules="required|phone"
              :validationTranslation="$t('models.user.phone')"
              fieldName="phone"
              fieldId="phone"
              fieldType="text"
              :label="$t('models.user.phone')"
              :required="true"
              :disabled="userExist && !userExistDifferentRole"
              @input="onChange('phone_display', internalPersonnalInformations.phone_display)" />
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ie_mixin from '@/mixin/ie'
import InputText from './InputText'
import { filterEmail } from '@/helpers/email'

export default {
  name: 'PersonnalInformationsFields',
  components: { InputText },
  props: {
    personnalInformations: { type: Object },
    userExist: { type: Boolean },
    existenceInEntity: { type: Boolean },
    userExistDifferentRole: { type: Boolean },
    isManager: { type: Boolean },
  },
  inject: ['$validator'],
  data() {
    return {
      internalPersonnalInformations: Object.assign({}, this.personnalInformations),
      specialChar: false
    }
  },
  computed: {
    ...mapGetters({
      mailCheckedEmail: 'users/emailSuggestion'
    })
  },
  watch: {
    personnalInformations: {
      handler() {
        this.internalPersonnalInformations = Object.assign({}, this.personnalInformations)
      }
    }
  },
  methods: {
    ...mapActions({
      resetMailSuggestion: 'users/resetMailSuggestion'
    }),
    onChange(field, value) {
      this.$emit('change', { field: field, value: value })
    },
    setEmail() {
      this.internalPersonnalInformations.email = this.mailCheckedEmail
      this.resetMailSuggestion()
    },
    onEmailInput(value) {
      this.onChange('email', value);
      this.specialChar = !filterEmail(value);
      this.$emit('update-special-char', this.specialChar);
    }
  }
}
</script>

<style lang="scss" scoped>
.form--suggestEmail {
  background-color: #F2F2F2;
  color: #6D7173;
  border-radius: 7px;
  padding: 7px;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.1rem;
  margin-bottom: 15px;
}
.email-suggestion {
  color: #e51349;
  cursor: pointer;
  text-decoration: underline;
}
.existence-notice {
  background: #e5f5f6;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  &.red {
    background: #fedad0;
    color: #e51349;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/form/PersonnalInformationsFields.vue